import type { FeatureManifest } from '../registry.js';
import { pendingDuel } from './local.js';
import { DuelMark } from './rail.js';

/**
 * CP-05 Duels (P2, R3): real-time 1v1 races on the same level over apps/realtime. Matched by
 * rating within 10 s or a labelled bot fills in; no boosters, no rescue. No level gate: the PRD
 * sets none. The map hook shows the result of a duel left mid-round (quit, reload), once.
 */
export default {
  id: 'duels',
  flag: 'duels',
  online: true,
  provides: ['duels', 'duelMatch', 'duelResult', 'duelHistory'],
  entry: { order: 7, icon: DuelMark, label: 'feature.duels.rail', testId: 'rail-duels', open: 'duels' },
  mapOrder: 21,
  mapDue: (a) => {
    if (a.services.sync.status === 'offline') return false;
    const p = pendingDuel(a);
    return p !== null && !a.session.checked.has(`duels:${p.duelId}`);
  },
  load: () => import('./index.js'),
} satisfies FeatureManifest;
